export function formatISO(date) {
    date = new Date(date);

    if (isNaN(date.getTime())) {
        return '';
    }

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
}

export function formatLocale(date) {
    date = new Date(date);

    return date.toLocaleDateString('en-gb', {
        day: 'numeric',
        month: 'long',
        timeZone: 'UTC',
        year: 'numeric',
    });
}

export function addDays(date, days) {
    date = new Date(date);
    date.setDate(date.getDate() + days);

    return date;
}

export function daysDifference(date1, date2) {
    const firstDate = new Date(date1);
    const secondDate = new Date(date2);
    const diffMs = secondDate.getTime() - firstDate.getTime();
    const aDayMs = 24 * 60 * 60 * 1000;

    return Math.round(diffMs / aDayMs);
}

export function initDeliveryDatePicker(element, onChange, maxDays = 84) {
    const maxDate = new Date();

    maxDate.setDate(maxDate.getDate() + maxDays);

    window.flatpickr(element, {
        dateFormat: 'j F Y',
        disableMobile: true,
        maxDate,
        minDate: new Date(),
        onChange: (selectedDates) => {
            if (onChange) onChange(selectedDates[0], element);
        },
    });
}

export function initStartDatePicker(element, date, onChange, maxDays = 84) {
    const now = new Date();
    const redemptionDelayDays = Math.ceil(parseInt(element.dataset.redemptionDelay) / 24);
    const startDate = new Date(date);

    now.setHours(0, 0, 0, 0);
    now.setDate(now.getDate() + redemptionDelayDays);
    startDate.setHours(0, 0, 0, 0);

    const difference = daysDifference(startDate, now);

    if (difference > 0) {
        startDate.setDate(startDate.getDate() + difference);
    }

    element.setAttribute('placeholder', startDate.toLocaleDateString('en-gb', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    }));

    const maxDate = addDays(startDate, maxDays);
    const picker = element._flatpickr;

    if (picker) {
        picker.set('minDate', startDate);
        picker.set('maxDate', maxDate);
        picker.setDate(startDate, true);
    } else {
        window.flatpickr(element, {
            dateFormat: 'j F Y',
            disableMobile: true,
            maxDate,
            minDate: startDate,
            onChange: (selectedDates) => {
                if (onChange) onChange(selectedDates[0], element);
            },
        });
    }
}
